import { omit, pick } from 'lodash';
import { schema } from 'normalizr';

const section = new schema.Entity(
  'sections',
  {},
  {
    idAttribute: '_id',
    processStrategy: (entity) => pick(entity, ['title', '_id', 'color', 'position'])
  },
);

const taskProject = new schema.Entity(
  'taskProjects',
  {
    sections: [section],
  },
  {
    idAttribute: (entity) => entity?.project?._id,
    processStrategy: (entity) => ({
      ...omit(entity, ['position', 'project', 'section', 'sectionTitle', 'task']),
      sections: entity?.project?.sections,
    }),
  },
);

const projectBasicById = new schema.Entity(
  'projects',
  {
    sections: [section],
  },
  {
    idAttribute: '_id',
    processStrategy: (entity) => pick(entity, ['archived', 'createdAt', 'metadata', 'sections', 'title', 'updatedAt', '__v', '_id'])
  },
);

const schemas = {
  GET_TASK_PROJECTS_SCHEMA: { data: { projects: [taskProject] } },
  GET_PROJECT_BASIC_FIELDS_BY_ID_SCHEMA: { data: projectBasicById }
};

export default schemas;
